<template>
    <div>
        <PageTitle
                :pages="pages"
                :title=titles.organisationsList
                v-if="showPageTitle"
        />
        <organisations-table
                :okPressed="okPressed"
                :showAddButton="showAddButton"
                @Domains="getDomains"
                @Organisation="getOrganisation"
                @OrganisationDomain="getOrgDomain"
                @Packs="getPacks"
                @deleted="handleDeleted"
        />
        <modal-success
                :title="titles.deleterganisationMessage"
                id="success-delete-organisation"
        />
        <modal-error
                :title="titles.cannotDeleterganisationMessage"
                id="cannot-delete-organisation"
        />
        <modal-delete
                :message="titles.confirmDeleterganisationMessage"
                @okPressed="handleOk"
                id="delete-organisation"
        />
        <modal-info
                :title="titles.cannotPaySubscriptionMessage"
                id="cannot-pay-subscription"
        />
    </div>
</template>

<script>
    import OrganisationsTable from './Table';
    import PageTitle from '@/components/common/PageTitle';
    import ModalDelete from '@/components/common/modal-confirm';
    import ModalSuccess from '../common/modal-success';
    import {titles} from '../../utils/general/titles.js';
    import ModalError from '../common/modal-error';
    import {name} from '../../utils/general/routers.js';
    import ModalInfo from '../common/modal-info';


    export default {
        name: 'index',
        props: {
            showPageTitle: {
                type: Boolean,
                default: true
            },
            showAddButton: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                titles,
                org: null,
                domains: null,
                okPressed: null,
                orgDomain: null,
                packs: null,
                pages: []
            };
        },
        components: {
            ModalInfo,
            ModalSuccess,
            ModalDelete,
            PageTitle,
            ModalError,
            OrganisationsTable
        },
        created() {
            this.pages.push(
                {
                    name: titles.organisationsList,
                    router: name.organisationList,
                    active: false
                },
                {
                    name: titles.organisationListExpression,
                    router: null,
                    active: true
                }
            );
        },
        methods: {
            handleOk(e) {
                this.okPressed = e;
            },
            handleDeleted(e) {
                this.okPressed = e;
            },
            getOrgDomain(e) {
                this.orgDomain = e;
            },
            getDomains(e) {
                this.domains = e;
            },
            getPacks(e) {
                this.packs = e;
            },
            getOrganisation(e) {
                this.org = e;
            }
        }
    };
</script>

<style scoped></style>
